import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const pageTitles = {
  '/admin/dashboard': 'Dashboard',
  '/admin/showrooms': 'Showrooms',
  '/admin/users': 'Users',
  '/admin/warranties': 'Warranty Registrations',
  '/admin/warranty/create': 'Create Warranty',
};

const getPageTitle = (pathname) => {
  if (pageTitles[pathname]) return pageTitles[pathname];
  if (pathname.startsWith('/admin/warranty/edit/')) return 'Edit Warranty';
  if (pathname.startsWith('/admin/warranty/view/')) return 'View Warranty';
  return 'Admin Panel';
};

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const pageTitle = getPageTitle(location.pathname);

  return (
    <div className="min-h-screen flex flex-col bg-syakar-light">

      {/* Full-width header */}
      <header className="w-full bg-white border-b border-gray-200 shadow-sm sticky top-0 z-20 flex items-center" style={{ height: '64px' }}>

        {/* Logo section — same width as sidebar (w-64 = 256px) */}
        <div className="flex items-center justify-start flex-shrink-0 px-5" style={{ width: '256px' }}>
          <a
            href="https://www.syakar.com.np/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/jyoti-logo.png"
              alt="Syakar Company"
              style={{ height: 40, width: 'auto' }}
            />
          </a>
        </div>

        {/* Page title + user info — aligns with main content area */}
        <div className="flex flex-1 items-center justify-between px-6">
          <div>
            <p className="text-base font-bold text-syakar-navy leading-none">{pageTitle}</p>
            <p className="text-xs text-gray-400 mt-0.5">Warranty Management System</p>
          </div>

          {/* User info */}
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-syakar-navy leading-none">
                {user.name || user.username || 'Admin'}
              </p>
              <p className="text-xs text-gray-400 mt-0.5">{user.email || ''}</p>
            </div>
            <div className="w-9 h-9 bg-syakar-red rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              {(user.name || user.username || user.email || 'A')[0].toUpperCase()}
            </div>
          </div>
        </div>
      </header>

      {/* Body: sidebar + content */}
      <div className="flex flex-1">
        <Sidebar />
        <main className="flex-1 min-w-0">
          {children}
        </main>
      </div>

    </div>
  );
};

export default AdminLayout;
